import { ROUTE_PATH } from "common/constants/sm-constants";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class AssignementNotAcceptedGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
      super(
        ' Non Accepted',
        ROUTE_PATH.assignment_not_accepted,
        ROUTE_PATH.assignmentGrid,
        false,
        false,
        8,
        false,
        false,
        [],
        false,
        [],
        { isDownloadExcel: false, excelFileName: '', btnLabel: '', headers: [] },
        false,
        null,
        false,
        true
      );
    }
  
    prepareHeaderList(): Headers[] {
      const headers: Headers[] = [];
      const studentName = new Headers(
        'Student Name',
        'student_name',
        false,
        true,
        'text'
      );
      const assigment = new Headers('Assigment', '', false, false, 'text');
      const ratingFromStudent = new Headers(
        'Rating from Student',
        'student_ratings',
        false,
        true,
        'text'
      );
      const feedbackFromStudent = new Headers(
        'Feedback from Student',
        'student_feedback',
        false,
        true,
        'text'
      );
      const feedbackToStudent = new Headers(
        'Feedback To Student',
        'trainer_feedback_to_student',
        false,
        true,
        'text'
      );
      const feedbackToAdmin = new Headers(
        'Feedback from Admin',
        'trainer_feedback_to_admin',
        false,
        true,
        'text'
      );
  
      headers.push(studentName);
      headers.push(assigment);
      headers.push(ratingFromStudent);
      headers.push(feedbackFromStudent);
      headers.push(feedbackToStudent);
      headers.push(feedbackToAdmin);
  
      return headers;
    }
  }